import { Navigate, useLocation } from "react-router-dom";
import usePageTitle from "@/hooks/usePageTitle";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import MobileFacilityLandingPage from "./MobileFacilityLandingPage";

export default function FacilityIndexPage() {
  usePageTitle("/facilities/:facilityId", "Facilities | Facility Details");
  const location = useLocation();
  const { isCompactLayout: isMobile } = useIsCompactLayout();

  // Show mobile landing page for mobile devices
  if (isMobile) {
    return <MobileFacilityLandingPage />;
  }

  // Redirect to details for desktop
  return <Navigate to={`${location.pathname}/details`} replace />;
}
